import { render, staticRenderFns } from "./quick-menu.vue?vue&type=template&id=037a073e&"
import script from "./quick-menu.vue?vue&type=script&lang=js&"
export * from "./quick-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports